import { StorageData } from "../storage-data";

export interface LanguageCompanyProfile {
    code: string;
    name: string;
    id: string;
}

export interface CompanyProfile {
    id: string;
    name: string;
    size: string;
    size_range: string;
    site?: string;
    image?: string;
    location?: string;
    description?: string;
    language?: LanguageCompanyProfile;
    currency?: string;
}

export interface GroupUser {
    id: string;
    name: string;
    email: string;
    phone: string;
    is_admin: boolean;
}

export interface Invite {
    inviter: string;
    company_id: string;
    company_name: string;
    email: string;
    created: string;
    cache_key: string;
}

export interface InviteResponse {
    token: string;
}

export interface RemoveTeamateResponse {
    loading: boolean;
    error: boolean;
}

export interface CompanyProfileState {
    companyProfile: StorageData<CompanyProfile | null, any>;
    groupUsers: StorageData<GroupUser[] | null, any>;
    invites: StorageData<Invite[] | null, any>;
    removedTeamate: StorageData<RemoveTeamateResponse | null, any>;
}

export const INITIAL_STATE: CompanyProfileState = {
    companyProfile: {
        data: null,
        loading: false,
        error: null,
    },
    groupUsers: {
        data: [],
        loading: false,
        error: null,
    },
    invites: {
        data: [],
        loading: false,
        error: null,
    },
    removedTeamate: {
        loading: false,
        error: false,
    }
}

export enum CompanyProfileActionTypes {
    GET_COMPANY_PROFILE = "@company-profile/GET_COMPANY_PROFILE",
    GET_COMPANY_PROFILE_SUCCESS = "@company-profile/GET_COMPANY_PROFILE_SUCCESS",
    GET_COMPANY_PROFILE_ERROR = "@company-profile/GET_COMPANY_PROFILE_ERROR",

    GET_GROUP_USERS = "@company-profile/GET_GROUP_USERS",
    GET_GROUP_USERS_SUCCESS = "@company-profile/GET_GROUP_USERS_SUCCESS",
    GET_GROUP_USERS_ERROR = "@company-profile/GET_GROUP_USERS_ERROR",

    GET_INVITES = "@company-profile/GET_INVITES",
    GET_INVITES_SUCCESS = "@company-profile/GET_INVITES_SUCCESS",
    GET_INVITES_ERROR = "@company-profile/GET_INVITES_ERROR",

    SEND_INVITE = "@company-profile/SEND_INVITE",
    SEND_INVITE_SUCCESS = "@company-profile/SEND_INVITE_SUCCESS",
    SEND_INVITE_ERROR = "@company-profile/SEND_INVITE_ERROR",

    INVALIDATE_INVITE = "@company-profile/INVALIDATE_INVITE",
    INVALIDATE_INVITE_SUCCESS = "@company-profile/INVALIDATE_INVITE_SUCCESS",
    INVALIDATE_INVITE_ERROR = "@company-profile/INVALIDATE_INVITE_ERROR",

    REMOVE_TEAMATE = "@company-profile/REMOVE_TEAMATE",
    REMOVE_TEAMATE_SUCCESS = "@company-profile/REMOVE_TEAMATE_SUCCESS",
    REMOVE_TEAMATE_ERROR = "@company-profile/REMOVE_TEAMATE_ERROR",
}
